import {useTranslation} from "react-i18next";
import ReturnArrow from "../buttons/ReturnArrow";
import DisplayView from "../DisplayView";
import React from "react";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 * @param String name: section name (required).
 * @param {JSX.Element} children: Elements that will be the content of the component (required).
 * @param useState view: value of state (optional).
 * @param useState setView: value update state (optional).
 * @param String link: navigation url (optional).
 * @param event onBack: event click (required).
 * @param Boolean hidden: If true, it does not show the 'arrow left' icon (optional).
 * @param {JSX.Element} divStack: Elements that will be the header content of the component (required).
 * @returns {JSX.Element}
 */
const Subtitle = (props) => {
    const { name, children, view, setView, link = '', onBack, hidden = false, divStack = null,table=false,className } = props;
    const { t } = useTranslation();

    return (
        <div className={`head ${className}`}>
            <div className='headLeft'>
                {!hidden && (link || onBack) && <ReturnArrow link={link} onBack={onBack} />}
                {table ? <h4 className={`ibl-h4 font-color-general-950 ibl-font-w-600`}>{t(name).toUpperCase()}</h4>
                    :<h3 className={"ibl-subtitle"}>{t(name).toUpperCase()}</h3>}
                {view && setView && <DisplayView view={view} setView={setView} />}
                {divStack != null &&
                <div className='d-flex subtitle-subaction'>
                    {divStack}
                </div>
                }
            </div>
            <div className={'container-top-right-btns'}>
                {children}
            </div>
        </div>
    );
};

export default Subtitle
